import { nsModel } from "../../lib/namespace";

export const invoiceNS = nsModel("invoice");
